"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUrl = void 0;
var _fixExcessiveSlashing = require("./fixExcessiveSlashing");
var queryParamsSerializer = function(params) {
    var searchParams = new URLSearchParams();
    Object.entries(params !== null && params !== void 0 ? params : {}).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (Array.isArray(value)) {
            value.forEach(function(v) {
                if (v != null) {
                    searchParams.append(key, encodeURIComponent(v.toString()));
                }
            });
        } else if (value != null) {
            searchParams.append(key, encodeURIComponent(value.toString()));
        }
    });
    return searchParams.toString();
};
var getUrl = function(config) {
    var _config_url, _config_baseURL;
    var requestUrl;
    if ((_config_url = config.url) === null || _config_url === void 0 ? void 0 : _config_url.startsWith('http')) {
        requestUrl = new URL(config.url);
    } else if ((_config_baseURL = config.baseURL) === null || _config_baseURL === void 0 ? void 0 : _config_baseURL.startsWith('http')) {
        var baseURLObject = new URL(config.baseURL);
        requestUrl = new URL((0, _fixExcessiveSlashing.fixExcessiveSlashing)("/".concat(baseURLObject.pathname, "/").concat(config.url)), baseURLObject.origin);
    } else {
        if (typeof window === 'undefined') {
            throw new TypeError('fetchAdapter - cannot construct URL, because request url does not have origin and no origin has been set in baseURL either');
        }
        var _config_url1;
        requestUrl = new URL((0, _fixExcessiveSlashing.fixExcessiveSlashing)("/".concat(config.baseURL, "/").concat((_config_url1 = config.url) !== null && _config_url1 !== void 0 ? _config_url1 : '')), window.location.origin);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- okay here
    requestUrl.search = queryParamsSerializer(config.params);
    return requestUrl.toString();
};
exports.getUrl = getUrl; //# sourceMappingURL=getUrl.js.map
